export const DEVICE_TYPE = {
  COLD_WATER:    0,
  HOT_WATER:     1,
  HEAT:          2,
  ELECTRICITY_1: 3,
  ELECTRICITY_2: 4,
  ELECTRICITY_3: 5,
  GAS:           6,
  HEAT_SPREADER: 21,
  HEAT_MW:       22,
  HEAT_KW:       23,
  HEAT_KW_TU:    24,
};
